<template>
    <div>
        <config-main-title>Modelos de Prontuário</config-main-title>

        <template v-if="!modelo">

            <div class="row mb-2">
                <div class="col col-12 col-md-6" v-if="$store.state.user.medico">
                    <div class="input-group mb-1">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1">
                                <i class="fas fa-user-md fa-fw"></i>
                            </span>
                        </div>
                        <label class="form form-control" disabled>{{ $store.state.user.medico.search }}</label>
                    </div>
                </div>
                <div class="col col-12 col-md-6" v-else>
                    <az-input 
                        placeholder="Todos"
                        icon="fas fa-user-md fa-fw" 
                        type="select" 
                        optionsMode="aql"
                        service="medicos.index"
                        optionsName="medicos-cadastro"
                        :optionsParm="{ ativos: true }"
                        v-model="medico" 
                        @change.native="selecionarMedico()" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Modelo
                    </button>
                </div>
            </div>

            <div class="row mb-3">
                <div class="col col-12">
                    <az-input 
                        ref="pesquisa"
                        placeholder="Pesquisar..."
                        icon="fas fa-search fa-fw"
                        v-model="search">
                        <template v-slot:buttonposb>
                            <print-export printid="impressao" />
                        </template>
                    </az-input>
                </div>
            </div>

        </template>

        <template v-if="!modelo && ( !lista || !lista.length ) && ( !medico && !$store.state.user.medico )">
            <az-empty-state msg="Nenhum modelo criado." />
        </template>

        <template v-else>

            <div class="mb-2 text-right" v-if="lista_tags && lista_tags.length">
                <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                        v-for="(tag, itx) in lista_tags" :key="itx">
                    <span class="badge badge-success mr-1" >
                        {{ tag }}
                    </span>
                </a>
            </div>

            <div id="impressao">

                <cabecalho-generico titulo="Modelos">
                    <div v-if="search">Pesquisa: {{ search }}</div>
                </cabecalho-generico>

                <ul class="list-group" v-if="!modelo && lista">
                    <li class="list-group-item d-flex justify-content-between" v-for="(item, index) in lista" :key="index">
                        <a href="#" @click.prevent="selecionar(item)" class="card-link">
                            {{ item.st_modelo_prontuario }}
                            <span class="badge badge-secondary">#{{ item.id_modelo_prontuario }}</span>
                            <span class="text-muted ml-3" v-if="item.procedimento && item.fl_formulario_opcional && !item.fl_formulario_consulta">
                                <i class="fas fa-plus mr-1"></i>
                                {{ item.procedimento.search }}
                            </span>
                            <span class="text-muted ml-3" v-else-if="item.procedimento">{{ item.procedimento.search }}</span>
                            <span class="text-muted ml-3" v-else-if="item.fl_formulario_consulta">consulta</span>
                        </a>
                        <div class="custom-control custom-switch ml-3" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + index"  v-model="item.fl_ativo" @change="toggle(item)">
                            <label class="custom-control-label" :for="'ativo-' + index"></label>
                        </div>
                        <div v-else>
                            <span v-if="item.js_classes">
                                <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                    v-for="(tag, itx) in item.js_classes" :key="itx">
                                    <span class="badge badge-success ml-1">
                                        {{ tag }}
                                    </span>
                                </a>
                            </span>
                            <span v-if="item.filtros_count" class="badge badge-secondary ml-2" title="Filtros">
                                <i class="fa fa-filter" aria-hidden="true"></i>
                                {{ item.filtros_count }}
                            </span>
                        </div>
                    </li>
                </ul>

            </div>

            <div class="card" v-if="modelo">
                <div class="card-header">
                    {{ modelo.st_modelo_prontuario }}
                </div>
                <div class="card-body">
                    <az-sub-title title="Título" />
                    <div class="row">
                        <div class="col col-12 col-md-6">
                            <az-input v-model="modelo.st_modelo_prontuario" type="text" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input 
                                type="checkbox-group" 
                                label="Formulário de Consulta Médica" 
                                :edicao="!modelo.fl_pre_atendimento"
                                v-model="modelo.fl_formulario_consulta" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input 
                                type="checkbox-group" 
                                label="Layout de Impressão" 
                                v-model="modelo.fl_layout_impressao" />
                        </div>
                    </div>

                    <!-- Herdar -->

                    <div class="row" v-if="!modelo.id_medico">
                        <div class="col col-12 offset-md-6 col-md-3">
                            <az-input 
                                type="checkbox-group" 
                                label="Pré-Atendimento" 
                                :edicao="!modelo.fl_formulario_consulta"
                                v-model="modelo.fl_pre_atendimento" />
                        </div>
                        <div class="col col-12 col-md-3" v-if="modelo.fl_pre_atendimento">
                            <az-input 
                                type="checkbox-group" 
                                label="Enviar no Pré-Cadastro" 
                                v-model="modelo.fl_pre_cadastro" />
                        </div>
                        <div class="col col-12 col-md-3" v-else-if="false && modelo.fl_formulario_consulta">
                            <az-input 
                                type="checkbox-group" 
                                label="Herdar Anterior no Lançamento" 
                                v-model="modelo.fl_herdar_anterior" />
                        </div>
                    </div>

                    <div class="row" velseif="1==1 || modelo.fl_formulario_consulta">
                        <div class="col col-12 col-md-3 offset-md-6">
                            <az-input 
                                type="checkbox-group" 
                                label="Herdar Anterior no Lançamento" 
                                v-model="modelo.fl_herdar_anterior" />
                        </div>
                    </div>

                    <div class="row" vif="modelo.fl_formulario_consulta || !modelo.fl_formulario_opcional">
                        <div class="col col-12 col-md-3 offset-md-6">
                            <az-input 
                                icon="fas fa-eye-slash"
                                type="select" 
                                placeholder="Sem restrição de visualização"
                                :optionsList="[
                                    { id: 'E', search: 'Apenas Para a Especialidade' },
                                    { id: 'U', search: 'Apenas Para o Responsável' },
                                    { id: 'L', search: 'Definir Visualização por Usuários' },
                                ]"
                                optionsData="id"
                                v-model="modelo.ch_ver_restricao" />
                        </div>
                        <div class="col col-12 col-md-3" v-if="modelo.ch_ver_restricao == 'E'">
                            <az-input icon="fas fa-filter fa-fw"
                                type="select"
                                optionsMode="esp-ativas"
                                optionsName="esp-ativas"
                                optionsData="id_especialidade"
                                v-model="modelo.id_especialidade" />
                        </div>
                        <div class="col col-12 col-md-3" v-else-if="modelo.ch_ver_restricao == 'L'">
                            <button type="button" class="btn btn-outline-secondary" @click="acessos(modelo)" :disabled="!modelo.id_modelo_prontuario">
                                <i class="fas fa-user-lock"></i>
                                <span v-if="modelo && modelo.acessos" class="badge badge-secondary ml-2">
                                    {{ modelo.acessos.length }}
                                </span>
                            </button>
                        </div>
                    </div>

                    <!-- fim Herdar -->

                    <div class="row" v-if="!modelo.id_medico && modelo.fl_pre_atendimento">
                        <div class="col col-12 offset-md-6 col-md-3">
                            <az-input 
                                type="checkbox-group" 
                                label="Coletar na Recepção" 
                                v-model="modelo.fl_coletar_na_recepcao" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input 
                                type="checkbox-group" 
                                label="Exibir no Prontuário" 
                                v-model="modelo.fl_exibir_no_pep" />
                        </div>
                    </div>

                    <div class="row" v-if="!modelo.id_medico && modelo.fl_pre_atendimento">
                        <div class="col col-12 offset-md-6 col-md-3">
                            <az-input 
                                type="checkbox-group" 
                                label="Coletar no Call Center" 
                                v-model="modelo.fl_coletar_no_callcenter" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input 
                                type="checkbox-group" 
                                label="Coletar no Portal" 
                                v-model="modelo.fl_coletar_no_portal" />
                        </div>
                    </div>

                    <div class="row" v-if="!modelo.id_medico && modelo.fl_pre_atendimento">
                        <div class="col col-12 offset-md-6 col-md-3">
                            <az-input 
                                type="checkbox-group" 
                                label="Exibir no Espelho de Atendimento" 
                                v-model="modelo.fl_exibir_no_espelho" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input 
                                type="checkbox-group" 
                                label="Coletar na Coleta" 
                                v-model="modelo.fl_coletar_na_coleta" />
                        </div>
                    </div>

                    <div class="mt-3" v-if="!modelo.id_medico && modelo.fl_pre_atendimento">
                        <div class="row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    type="number"
                                    label="Idade Mínima"
                                    placeholder="0"
                                    v-model="modelo.in_paciente_idade_minima" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    type="number"
                                    label="Idade Máxima"
                                    placeholder="999"
                                    v-model="modelo.in_paciente_idade_maxima" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    type="sexo"
                                    placeholder="Qualquer"
                                    label="Sexo do Paciente"
                                    v-model="modelo.ch_paciente_sexo" />
                            </div>
                        </div>
                    </div>

                    <div class="mt-3" v-if="modelo.js_heranca">
                        <az-sub-title :title="'Herdar Anterior Para...' + ( modelo.fl_herdar_anterior ? '' : ' (Manualmente)' ) " />
                        <div class="row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    type="checkbox-group"
                                    label="Mesmo Procedimento"
                                    v-model="modelo.js_heranca.proc" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    type="checkbox-group"
                                    label="Mesmo Profissional"
                                    v-model="modelo.js_heranca.medico" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    type="checkbox-group"
                                    label="Mesmo Modelo"
                                    v-model="modelo.js_heranca.modelo" />
                            </div>
                        </div>
                    </div>

                    <div class="mt-3">
                        <az-sub-title title="Procedimento" />
                        <div class="row" v-if="!modelo.fl_pre_atendimento">
                            <div class="col col-12 col-md-6">
                                <div v-if="!modelo.id_procedimento" class="mb-3">
                                    <ul class="list-group mb-2">
                                        <li class="list-group-item" v-for="(proced, ipx) in modelo.procedimento_lista" :key="ipx">
                                            {{ proced.procedimento.search }}
                                        </li>
                                    </ul>
                                    <button class="btn btn-outline-primary btn-sm" type="button" @click="editar_lista_procedimentos(modelo)"
                                        :disabled="!modelo.id_modelo_prontuario">
                                        Editar Lista de Procedimentos
                                    </button>
                                </div>
                                <az-input
                                    v-else
                                    type="select"
                                    optionsMode="json"
                                    optionsData="id_procedimento"
                                    :optionsList="procedimentos"
                                    v-model="modelo.id_procedimento" />
                            </div>
                            <template v-if="!modelo.fl_formulario_consulta">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        type="checkbox-group"
                                        label="Fixar na Barra de Ferramentas"
                                        v-if="modelo.id_procedimento || ( modelo.procedimento_lista && modelo.procedimento_lista.length )"
                                        v-model="modelo.fl_formulario_opcional" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        type="checkbox-group"
                                        label="Acessível para Recepção Imprimir"
                                        v-if="( modelo.id_procedimento || ( modelo.procedimento_lista && modelo.procedimento_lista.length ) )
                                            && modelo.fl_formulario_opcional"
                                        v-model="modelo.fl_acesso_recepcao" />
                                </div>
                            </template>
                        </div>
                        <template v-else-if="modelo.id_modelo_prontuario">
                            <ul class="list-group mb-2">
                                <li class="list-group-item" v-for="(proced, ipx) in modelo.procedimento_lista" :key="ipx">
                                    {{ proced.procedimento.search }}
                                </li>
                            </ul>
                            <button class="btn btn-outline-primary btn-sm" type="button" @click="editar_lista_procedimentos(modelo)">
                                Editar Lista de Procedimentos
                            </button>
                        </template>
                    </div>

                    <div class="row"> <!-- v-if="!modelo.fl_formulario_consulta" -->
                        <div class="col col-12 col-md-9">
                            <az-input
                                label="Título para Impressão"
                                placeholder="Padrão..."
                                :edicao="!modelo.fl_sem_titulo_impressao"
                                v-model="modelo.st_titulo_impressao" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <small class="form-text text-muted text-nowrap text-truncate">
                                &nbsp;
                            </small>
                            <az-input
                                type="checkbox-group"
                                label="Sem Título na Impressão"
                                v-model="modelo.fl_sem_titulo_impressao" />
                        </div>
                    </div>

                    <h3 class="alert alert-dark mt-3">Formulário</h3>
                    <div class="form-row">
                        <div class="col col-12 col-md-3">
                            <az-input
                                sizing="sm"
                                type="checkbox-group"
                                label="Compacto"
                                v-model="modelo.fl_compact" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input
                                sizing="sm"
                                type="checkbox-group"
                                label="Espaçamento Reduzido"
                                v-model="modelo.fl_espaco_reduzido" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input
                                sizing="sm"
                                type="checkbox-group"
                                label="Na visualização, exibir campos vazios"
                                v-model="modelo.fl_view_vazio" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input
                                sizing="sm"
                                type="select"
                                placeholder="Padrão"
                                icon="fas fa-text-height"
                                :optionsList="[
                                    { id: 'g', search: 'Grande' },
                                    { id: 'lg', search: 'Muito Grande' },
                                ]"
                                optionsData="id"
                                v-model="modelo.st_form_tamanho_padrao" />
                        </div>
                    </div>

                    <formulario 
                        :gutters="modelo.fl_espaco_reduzido ? true : false"
                        :compact="modelo.fl_compact"
                        :tamanhoform="modelo.st_form_tamanho_padrao"
                        v-model="modelo.estrutura" 
                        v-if="modelo" 
                        :saved="saved" 
                        :config="true" 
                        @atualizar="atualizar()"/>

                    <template v-if="modelo && modelo.fl_layout_impressao">
                        <h3 class="alert alert-dark mt-3">Layout de Impressão</h3>

                        <div class="row mb-2" v-if="1 == 1 || modelo.fl_layout_word || $store.state.user.id_usuario == 1">
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    type="checkbox-group" 
                                    label="Layout de Impressão em Arquivo Word" 
                                    v-model="modelo.fl_layout_word" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    type="checkbox-group" 
                                    label="Layout de Impressão em MarkDown" 
                                    v-model="modelo.fl_layout_markdown" />
                            </div>
                        </div>

                        <template v-if="modelo.fl_layout_word">

                            <div v-if="modelo.id_modelo_prontuario">

                                <ul class="list-group mb-3" v-if="modelo.arquivos">
                                    <li class="list-group-item" v-for="(arq, iax) in modelo.arquivos" :key="iax">
                                        <a :href="arq.arquivo.temporary_url" target="_blank" class="mr-2">
                                            <i class="fa-solid fa-cloud-arrow-down"></i>
                                        </a>
                                        {{ arq.arquivo.st_titulo }} 
                                    </li>
                                </ul>

                                <button class="btn btn-primary mr-1" type="button" @click="enviar_arquivo()">
                                    <i class="fas fa-plus mr-2"></i>
                                    Arquivo
                                </button>

                                <az-file-upload
                                    :blockcelular="true"
                                    extensions="docx"
                                    ref="upload"
                                    @refresh="refresh_arquivos"
                                    :arquivos="modelo.arquivos"
                                    :parms="{ model_type: 'modeloProntuario', model_id: modelo.id_modelo_prontuario }" />

                            </div>

                            <div class="alert alert-info" v-else> 
                                Necessário atualizar o modelo para poder enviar o arquivo.
                            </div>

                        </template>

                        <template v-else>
                            <div class="row">
                                <div class="col col-12-col-md-6">
                                    <small class="text-muted">Papel</small>
                                    <select class="form-control" type="select" v-model="modelo.st_papel">
                                        <option value="">Selecionado</option>
                                        <option value="A4">A4</option>
                                        <option value="A4-T">A4 (Timbrado)</option>
                                        <option value="A4-NT">A4 (Não Timbrado)</option>
                                        <option value="A5">A5</option>
                                        <option value="A5-T">A5 (Timbrado)</option>
                                        <option value="A5-NT">A5 (Não Timbrado)</option>
                                    </select>
                                </div>
                                <div class="col col-12-col-md-6">
                                    <small class="text-muted">Tamanho da Fonte para Impressão</small>
                                    <select class="form-control" type="select" v-model="modelo.st_fonte_tamanho">
                                        <option value="">Padrão</option>
                                        <option value="14">14</option>
                                        <option value="13">13</option>
                                        <option value="12">12</option>
                                        <option value="11">11</option>
                                        <option value="10">10</option>
                                        <option value="9">9 (Padrão)</option>
                                        <option value="8">8</option>
                                        <option value="7">7</option>
                                    </select>
                                </div>
                            </div>

                            <template v-if="modelo.fl_layout_markdown">
                                <div class="row mt-3">
                                    <div class="col col-12 col-md-6">
                                        <az-input   
                                            label="Layout Markdown"
                                            type="textarea"
                                            rows="10"
                                            v-model="modelo.st_layout_impressao" />

                                        <template v-if="lista_campos && lista_campos.length">
                                            <az-input
                                                sizing="sm"
                                                icon="fa fa-plus"
                                                type="select"
                                                optionsMode="json"
                                                :optionsList="lista_campos"
                                                optionsDisplay="search"
                                                optionsData="id"
                                                v-model="novoCampo"
                                                @input="incluir_novo_campo()" />
                                        </template>
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <vue-markdown :source="modelo.st_layout_impressao" />
                                    </div>
                                </div>
                            </template>

                            <template v-else>
                                <formulario 
                                    v-model="modelo.st_layout_impressao" 
                                    :saved="saved" 
                                    mode="print" 
                                    :config="true" 
                                    :base="modelo.estrutura" 
                                    @atualizar="atualizar()" />
                            </template> 
                        </template>

                    </template>

                    <hr>

                    <div class="row">
                        <div class="col col-12">
                            <small class="text-muted">Classificação</small>
                            <multiselect
                                v-model="modelo.js_classes"
                                :options="options_classes"
                                :multiple="true"
                                :taggable="true"
                                @tag="addTag"
                                placeholder="Selecione uma classificação..."
                                selectLabel="Pressione [ENTER] para selecionar"
                                deselectLabel="Pressione [ENTER] para remover"
                                tagPlaceholder="Pressione [ENTER] para incluir"
                                selectedLabel="Selecionado">
                                <template slot="noOptions">
                                    Nenhuma classificação criada.
                                </template>
                            </multiselect>
                        </div>
                    </div>

                    <!-- Cabeçalho -->

                    <div class="row mt-3">
                        <div class="col col-12">
                            <az-input
                                label="Modelo de Cabeçalho"
                                type="select"
                                placeholder="Padrão do Procedimento..."
                                optionsMode="aql"
                                service="cabecalhos.index"
                                :optionsParm="{ ativos: true }"
                                optionsData="id_cabecalho_laudo"
                                v-model="modelo.id_cabecalho_laudo" />
                        </div>
                    </div>

                    <!-- Filtros de Exibição da Recepção -->
                    <div class="mt-3" v-if="!modelo.id_medico">
                        <filtro-model 
                            v-model="modelo.filtros" 
                            :validate="validate" 
                            :opcoes="lista_opcoes_filtro" />
                    </div>

                </div>
            </div>

            <div v-if="modelo">
            
                <br><br><br>
            
                <nav class="navbar fixed-bottom navbar-light bg-light" >
                    <div>
                        <az-submit class="mr-2" @click="atualizar ()">Atualizar</az-submit>
                        <button class="btn btn-secondary mr-2" type="button" @click="fechar()">Fechar</button>
                        <az-audit-log-button model="modeloProntuario" :id="modelo.id_modelo_prontuario" />
                    </div>
                </nav>

            </div>

            <template v-if="!modelo && id_medico && medicoUnidade && medicoUnidade.length == 1">

                <ul class="list-group mt-3" v-if="!modelo && id_medico && medicoUnidade && medicoUnidade.length == 1">
                    <li class="list-group-item active">Modelos Vinculados para o Profissional</li>
                    <li class="list-group-item d-flex justify-content-between">
                        <div>
                            <span class="text-muted mr-2">Consulta Inicial:</span>
                            <span v-if="medicoUnidade[0].modelo_consulta_inicial">{{ medicoUnidade[0].modelo_consulta_inicial.search }}</span>
                            <span v-else>Não Definido</span>
                        </div>
                        <div>
                            <button type="button" class="btn btn-sm btn-outline-success" title="Selecionar Modelo" @click="selecionar_modelo_medico(medicoUnidade[0], 'inicial')">
                                <i class="fa-solid fa-clipboard-check"></i>
                            </button>
                        </div>
                    </li>
                    <li class="list-group-item d-flex justify-content-between">
                        <div>
                            <span class="text-muted mr-2">Consulta Revisão:</span>
                            <span v-if="medicoUnidade[0].modelo_consulta_revisao">{{ medicoUnidade[0].modelo_consulta_revisao.search }}</span>
                            <span v-else>Não Definido</span>
                        </div>
                        <div>
                            <button type="button" class="btn btn-sm btn-outline-success" title="Selecionar Modelo" @click="selecionar_modelo_medico(medicoUnidade[0], 'revisao')">
                                <i class="fa-solid fa-clipboard-check"></i>
                            </button>
                        </div>
                    </li>
                    <li class="list-group-item d-flex justify-content-between">
                        <div>
                            <span class="text-muted mr-2">Consulta Subsequente:</span>
                            <span v-if="medicoUnidade[0].modelo_consulta_subsequente">{{ medicoUnidade[0].modelo_consulta_subsequente.search }}</span>
                            <span v-else>Não Definido</span>
                        </div>
                        <div>
                            <button type="button" class="btn btn-sm btn-outline-success" title="Selecionar Modelo" @click="selecionar_modelo_medico(medicoUnidade[0], 'subsequente')">
                                <i class="fa-solid fa-clipboard-check"></i>
                            </button>
                        </div>
                    </li>
                    <li class="list-group-item d-flex justify-content-between" v-for="(item, idx) in procedimentos_com_modelo" :key="idx">
                        <div>
                            <span class="text-muted mr-2">{{ item.procedimento.search }}:</span>
                            <span>{{ item.modelo_prontuario.search }}</span>
                        </div>
                        <div>
                            <button type="button" class="btn btn-sm btn-outline-success" title="Selecionar Modelo" @click="selecionar_modelo_medico(medicoUnidade[0], null, item.procedimento)">
                                <i class="fa-solid fa-clipboard-check"></i>
                            </button>
                        </div>
                    </li>
                </ul>

                <az-input
                    class="mt-3"
                    placeholder="Selecionar Procedimento..."
                    sizing="sm"
                    icon="fa fa-plus fa-fw"
                    type="autocomplete"
                    optionsMode="aql"
                    :optionsName="'medico_procedimento_unidades.index.modelos.' + id_medico"
                    service="medico_procedimento_unidades.index"
                    optionsDisplay="search"
                    :optionsSync="false"
                    :optionsParm="{
                        id_medico: id_medico,
                        ativos: true, 
                    }"
                    v-model="novo_proc"
                    @input="selecionar_modelo_procedimento" />

            </template>

            <div class="mt-3" v-if="1 == 0">
                <pre class="alert alert-info" v-if="1 == 1">{{ medicoUnidade }}</pre>
                <pre class="alert alert-warning" v-if="1 == 1">{{ procedimentos }}</pre>
            </div>

        </template>

        <procedimento-lista ref="proclista" @refresh="atualizar_lista_procedimento" />

        <!-- Modal Seleção Modelo -->
        <div class="modal fade" id="selecaoModeloMedicoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Selecione o Modelo</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!lista_selecao || !lista_selecao.length"></az-empty-state>

                        <div v-else>
                            <div class="list-group">
                                <button type="button" class="list-group-item list-group-item-action" v-for="(mod, imx) in lista_selecao" :key="imx" @click="atualizar_modelo_medico(mod)" :disabled="$store.state.loading">
                                    {{ mod.st_modelo_prontuario }}
                                    <span class="badge badge-secondary ml-2">#{{ mod.id_modelo_prontuario }}</span>

                                    <i class="fa-solid fa-user-doctor ml-3" v-if="mod.id_medico"></i>
                                </button>
                            </div>
                            <pre v-if="1==0">{{ lista_selecao }}</pre>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <edicao-acessos ref="acessos" refresh2="load()" />
        
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import Formulario from '../Formulario.vue';
import AzInput from '../../../shared/forms/AzInput.vue';
import AzSubTitle from '../../../util/AzSubTitle.vue';
import ConfigMainTitle from '../../../cadastros/shared/ConfigMainTitle.vue';
import AzAuditLogButton from '../../../util/AzAuditLogButton.vue';

import AzSubmit from '../../../util/AzSubmit.vue';
import AzEmptyState from '../../../util/AzEmptyState.vue';

import ProcedimentoLista from '../../../shared/ProcedimentoLista.vue';
import Multiselect from 'vue-multiselect';

import AzFileUpload from "../../../util/AzFileUpload.vue";
import VueMarkdown from 'vue-markdown'

import FiltroModel from '../../../cadastros/shared/FiltroModel.vue';

import PrintExport from '../../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../../relatorios/shared/CabecalhoGenerico.vue';

import EdicaoAcessos from '../../../cadastros/shared/EdicaoAcessos.vue';



export default {
    data () { 
        return { 
            modelos: [],
            modelo: null,
            saved: true,
            procedimentos: null, 
            medicoUnidade: null, 
            vinculoProcedimento: "", 
            viewMode: "A",
            id_medico: null, 
            medico: "", 
            bc: [],
            search: "", 
            options_classes: [], 
            novoCampo: "", 
            lista_selecao: null, 
            medico_unidade: null, 
            validate: false, 
            novo_proc: null, 
        }
    },
    
    components: { 
        AzInput,
        AzSubTitle,
        Formulario,
        ConfigMainTitle, 
        AzEmptyState, 
        AzSubmit, 
        AzAuditLogButton, 
        ProcedimentoLista,
        Multiselect,  
        AzFileUpload,
        FiltroModel, 
        PrintExport, 
        CabecalhoGenerico,
        VueMarkdown,
        EdicaoAcessos, 
    },

    props: ['id'],
    
    computed: { 
        lista: function () { 
            let reg = this.$util.getregex(this.search);
            
            return this.modelos.filter(item => this.viewMode == 'T' || item.fl_ativo)
                .filter(item => !this.search || reg.test(JSON.stringify(item)) );
        },

        lista_tags: function () { 
            if ( !this.modelos )
                return [];

            return  _.orderBy(
                _.uniq(
                    this.modelos.reduce((carry, item) => { 
                        return item.js_classes ? carry.concat(item.js_classes) : carry;
                    }, [])
                )
            );
        },

        procedimentos_com_modelo: function() { 
            if ( !this.procedimentos )
                return [];

            return this.procedimentos.filter(item => item.id_modelo_prontuario);
        },

        lista_campos: function () { 
            if ( !this.modelo || !this.modelo.estrutura )
                return [];

            let valores = this.modelo.estrutura;
      
            valores = valores.flatMap(x => ( x.type == 'group' && x.campos ) ? x.campos : x);
            valores = valores.flatMap(x => ( x.type == 'group' && x.campos ) ? x.campos : x);
            valores = valores.flatMap(x => ( x.type == 'group' && x.campos ) ? x.campos : x);

            return valores.filter(campo => campo.id)
                .map(campo => { 
                    campo.search = ( campo.label ? campo.label : 'Sem Título' ) + " (#" + campo.id + ")";
                    return campo;
                });
        },

        lista_opcoes_filtro: function () {
            let opcoes = [
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
                {id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'},
            ];

            return _.orderBy(opcoes, 'search');
        },
    },

    methods: { 
        selecionar_modelo_procedimento () { 
            
            if ( this.novo_proc ) { 

                let item = this.procedimentos.find(pc => pc.id_medico_procedimento_unidade == this.novo_proc.id_medico_procedimento_unidade)

                this.selecionar_modelo_medico(item, null, item.procedimento);

                this.$nextTick(() => { 
                    this.novo_proc = ""; 
                });

            }

        },

        acessos (modelo) { 
            this.$refs.acessos.abrir('App\\azure\\modeloProntuario', modelo.id_modelo_prontuario);
        },

        selecionar_modelo_medico (item, tipo = null, procedimento = null) { 
            this.medico_unidade = _.cloneDeep(item);
            this.medico_unidade.tipo = tipo;
            this.medico_unidade.id_procedimento = procedimento ? procedimento.id_procedimento : null, 

            this.lista_selecao = null;

            $('#selecaoModeloMedicoModal').modal('show');

            this.$util.load(this, { 
                service: "modelos",
                func: "index", 
                parms: { 
                    mode: "selecao",
                    id_medico: this.medico ? this.medico.id_pessoa : -1, 
                    id_procedimento: item ? item.id_procedimento : null,
                    id_classe_procedimento: 1, 
                    where: { 
                        fl_ativo: true 
                    },
                },
                loadTo: res => { 
                    this.lista_selecao = res;
                }
            });
            
        },

        atualizar_modelo_medico (modelo) { 
            if ( this.medico_unidade.tipo ) { 
                this.medico_unidade["id_modelo_padrao_" + this.medico_unidade.tipo] = modelo.id_modelo_prontuario;
            
                this.$util.atualizar(this, {
                    service: "medico_unidades",
                    dados: this.medico_unidade,
                    reload: true, 
                    toast: true, 
                    modal: 'selecaoModeloMedicoModal'
                });
            } else if ( this.medico_unidade.id_procedimento ) { 

                this.$util.load(this, {
                    service: "medico_procedimento_unidades",
                    func: 'index',
                    parms: { 
                        where: { 
                            id_medico_unidade: this.medico_unidade.id_medico_unidade,
                            id_procedimento: this.medico_unidade.id_procedimento,
                            fl_ativo: 1
                        }
                    },
                    loadTo: res => { 
                        if ( res && res.length == 1 ) { 
                            res[0].id_modelo_prontuario = modelo.id_modelo_prontuario;

                            this.$util.atualizar(this, {
                                service: "medico_procedimento_unidades",
                                dados: res[0],
                                reload: true, 
                                toast: true, 
                                modal: 'selecaoModeloMedicoModal'
                            });
                        }                       
                    }
                });

            }
        },

        incluir_novo_campo() {
            if ( !this.novoCampo )
                return;

            this.modelo.st_layout_impressao = this.modelo.st_layout_impressao + ' #' + this.novoCampo;

            this.novoCampo = null;

            this.$nextTick(() => {
                this.novoCampo = "";
            });
        },

        enviar_arquivo() {
            this.$refs.upload.abrir();
        },

        refresh_arquivos() { 
            this.load();
            this.$util.loadItem(this, { 
                service: 'modelos',
                func: 'show',
                id: this.modelo.id_modelo_prontuario,
            })
            .then(res => { 
                this.modelo.arquivos = res.arquivos;
            })
            .finally(() => { 
                this.$store.commit('loading', false);
            });
        },
        
        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.modelo.js_classes )
                this.modelo.js_classes = [];

            this.modelo.js_classes.push(newTag);
        },

        atualizar_lista_procedimento (lista) { 
            this.modelo.procedimento_lista = lista;
        },

        editar_lista_procedimentos(modelo) { 
            this.$refs.proclista.abrir('modeloProntuario', modelo.id_modelo_prontuario);
        },

        pesquisar() { 
            //
        },

        selecionarMedico() { 
            this.$store.commit('loading', true);
            this.modelos = [];
            
            this.id_medico = this.medico ? this.medico.id_pessoa : null;

            this.load();
        },

        fechar() { 
            this.modelo = null;

            this.bc = this.bc.slice(0, 2);
            this.$store.commit('setBreadcrumb', this.bc);

            this.$router.replace({ name: 'modelos' });
        },

        toggle(item) { 
            this.$util.toggle(this, { 
                service: 'modelos',
                dados: item, 
            });
        },

        download () { 
            var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.modelo.estrutura));
            var downloadAnchorNode = document.createElement('a');
            downloadAnchorNode.setAttribute("href",     dataStr);
            downloadAnchorNode.setAttribute("download", "modelo.json");
            document.body.appendChild(downloadAnchorNode); 
            downloadAnchorNode.click();
            downloadAnchorNode.remove();
        },

        vincularProcedimento () { 

            if ( !this.vinculoProcedimento )
                return; 

            let dados = { ...this.vinculoProcedimento };

            dados.id_modelo_prontuario = this.modelo.id_modelo_prontuario;

            this.modelo.medico_procedimento_unidades.push(dados);

            this.$nextTick(() => { 
                this.vinculoProcedimento = "";
            });

        }, 

        selecionar (modelo) { 

            this.validate = false;

            this.$util.load(this, { 
                service: 'modelos',
                func: 'show',
                parms: { 
                    id: modelo.id_modelo_prontuario,
                    cadastro: true, 
                },
                loadTo: res => { 
                    this.modelo = res;
                    this.$router.replace({ name: 'modelos', params: { id: this.modelo.id_modelo_prontuario }});

                    this.bc = this.bc.slice(0,2);

                    this.bc.push({ 
                        name: this.modelo.st_modelo_prontuario, 
                        path: "/modelos", 
                        route_name: "modelos",  
                        params: { 
                            id: this.modelo.id_modelo_prontuario 
                        } 
                    });

                    this.$store.commit('setBreadcrumb', this.bc);
                }
            })
            
        },

        load () { 
            this.$store.commit('loading', true);
            let filtro = this.id_medico ? { id_medico: this.id_medico } : {};

            let query = { q: [
                { 
                    name: 'modelos.index',
                    id: 'modelos',
                    parms: { 
                        ...filtro, 
                       cadastro: true, 
                    },
                },
                { 
                    name: this.id_medico ? 'medico_procedimento_unidades.index' : 'procedimentos.index',
                    id: 'procedimentos',
                    parms: { 
                        where: this.id_medico ? { fl_ativo: true } : {},
                        ...filtro, 
                        agenda: true, 
                        modelo: true, 
                    },
                    
                },
                { 
                    name: 'medico_unidades.index',
                    id: 'medico_unidade',
                    parms: { 
                        where: { 
                            ...filtro,  
                        }, 
                        with: [
                            'modelo_consulta_inicial:id_modelo_prontuario,st_modelo_prontuario,id_medico',
                            'modelo_consulta_revisao:id_modelo_prontuario,st_modelo_prontuario,id_medico',
                            'modelo_consulta_subsequente:id_modelo_prontuario,st_modelo_prontuario,id_medico'
                        ],
                    },
                },
            ]};

            this.axios.post('/aql?a=modelos.index', query)
                .then(res => { 
                    if ( res.data.modelos.status == 200 ) { 
                        this.modelos = res.data.modelos.data;
                    }

                    if ( res.data.procedimentos.status == 200 ) { 
                        this.procedimentos = res.data.procedimentos.data;
                    }

                    if ( res.data.medico_unidade.status == 200 ) { 
                        this.medicoUnidade = res.data.medico_unidade.data;
                    }

                    if ( this.id ) { 
                        this.selecionar(this.modelos.find(item => item.id_modelo_prontuario == this.id));
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });
        },

        excluir(modelo) { 
            console.log(modelo);
            alert('Em desenvolvimento...');
        },

        abrir () { 
            $('#formularioConfigModal').modal('show');
        },

        incluir () { 
            this.modelo = { 
                st_modelo_prontuario: 'Modelo',
                id_medico: this.id_medico,
                fl_layout_impressao: false, 
                fl_layout_word: false,  
                fl_layout_markdown: false,
                ch_ver_restricao: "",
                id_especialidade: "", 
                estrutura: [],
                procedimento_lista: [], 
            };
        },

        atualizar () { 

            let query = { q: [
                { 
                    name: 'modelos.store',
                    id: 'modelo',
                    parms: { 
                        ...this.modelo, 
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.modelo.status == 200 ) { 

                        if ( !this.modelo.id_modelo_prontuario ) { 
                            this.modelo.id_modelo_prontuario = res.data.modelo.data.id_modelo_prontuario;
                        }

                        this.load ();
                        this.$toast.add({
                            severity: "success",
                            summary: "Formulário Atualizado!",
                            detail: res.data.modelo.data.st_modelo_prontuario,
                            life: 3000
                        });

                    }
                });

        }
    },

    created() { 
        if ( this.$store.state.user.medico ) { 
            this.id_medico = this.$store.state.user.id_pessoa;
        }
    },

    mounted () { 
        this.bc = [
            { name: "Configurações", path: "/cadastros" },
            { 
                name: "Modelos de Prontuário", 
                method: this.fechar
            }
        ];

        this.$store.commit("setBreadcrumb", this.bc);

        /*
        if ( this.id ) { 
            this.$router.replace({ name: 'modelos' });
        }
        */

        this.$refs['pesquisa'].$refs.input.focus ();

        this.load ();

        this.$util.loadItem(this, { 
            service: 'modelos',
            func: 'tags',
        })
        .then(res => { 
            this.options_classes = res;
        });
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>